import {
  PAGE_PORTAL_COMPANY,
  PAGE_PORTAL_DASHBOARD,
  PAGE_PORTAL_FINANCE,
  PAGE_PORTAL_FINANCE_INVOICES,
  PAGE_PORTAL_FINANCE_PAYMENTS,
  PAGE_PORTAL_FINANCE_RECEIPTS_LIST,
  PAGE_PORTAL_INVENTORY_CATEGORIES,
  PAGE_PORTAL_INVENTORY_PRODUCT,
  PAGE_PORTAL_ORDERS_SALES_LIST,
  PAGE_PORTAL_PROFILE,
  PAGE_PORTAL_STORE,
  PAGE_PORTAL_STORES,
  PORTAL_PREFIX
} from "@kivunova/kivufrontendcommon";
import { UserRole } from "../../components/Profile/enums/profileEnums";
import {
  canAccessCategoryList,
  canAccessDashboardAnalytics,
  canAccessProductCatalog,
  canAccessStoreFinanceNav,
  canAccessStoreSalesOrdersNav
} from "../../components/Navigation/constants/sidebarRoleAccess";
import type { SidebarNavConfigEntry } from "../types/sidebarNavConfigTypes";

/** Retail portal nav — same items as legacy SidebarConfig before MBT-4. */
export const RETAIL_SIDEBAR_CONFIG: SidebarNavConfigEntry[] = [
  {
    labelKey: "sidebar-overview",
    defaultLabel: "Overview",
    icon: "grid",
    path: `${PORTAL_PREFIX}/${PAGE_PORTAL_DASHBOARD}`,
    testId: "sidebar-nav-dashboard",
    visible: canAccessDashboardAnalytics
  },
  {
    labelKey: "sidebar-products",
    defaultLabel: "Products",
    icon: "shoppingCart",
    path: `${PORTAL_PREFIX}/${PAGE_PORTAL_INVENTORY_PRODUCT}`,
    testId: "sidebar-nav-inventory-products",
    visible: canAccessProductCatalog
  },
  {
    labelKey: "sidebar-categories",
    defaultLabel: "Categories",
    icon: "category",
    path: `${PORTAL_PREFIX}/${PAGE_PORTAL_INVENTORY_CATEGORIES}`,
    testId: "sidebar-nav-inventory-categories",
    visible: canAccessCategoryList
  },
  {
    labelKey: "sidebar-orders",
    defaultLabel: "Orders",
    icon: "orders",
    path: `${PORTAL_PREFIX}/${PAGE_PORTAL_ORDERS_SALES_LIST}`,
    testId: "sidebar-nav-orders-sales",
    visible: canAccessStoreSalesOrdersNav
  },
  {
    labelKey: "sidebar-finance",
    defaultLabel: "Finance",
    icon: "priceCheck",
    path: `${PORTAL_PREFIX}/${PAGE_PORTAL_FINANCE}`,
    testId: "sidebar-nav-finance",
    visible: canAccessStoreFinanceNav,
    children: [
      {
        labelKey: "sidebar-payments",
        defaultLabel: "Payments",
        icon: "paymentOutlined",
        path: `${PORTAL_PREFIX}/${PAGE_PORTAL_FINANCE_PAYMENTS}`,
        testId: "sidebar-nav-finance-payments"
      },
      {
        labelKey: "sidebar-invoices",
        defaultLabel: "Invoices",
        icon: "receipt",
        path: `${PORTAL_PREFIX}/${PAGE_PORTAL_FINANCE_INVOICES}`,
        testId: "sidebar-nav-finance-invoices"
      },
      {
        labelKey: "sidebar-receipts",
        defaultLabel: "Receipts",
        icon: "receipt",
        path: `${PORTAL_PREFIX}/${PAGE_PORTAL_FINANCE_RECEIPTS_LIST}`,
        testId: "sidebar-nav-finance-receipts"
      }
    ]
  },
  {
    labelKey: "sidebar-profile",
    defaultLabel: "Profile",
    icon: "person",
    path: `${PORTAL_PREFIX}/${PAGE_PORTAL_PROFILE}`,
    testId: "sidebar-nav-profile"
  },
  {
    labelKey: "sidebar-stores",
    defaultLabel: "Stores",
    icon: "store",
    path: `${PORTAL_PREFIX}/${PAGE_PORTAL_STORES}`,
    testId: "sidebar-nav-stores",
    visible: (role) => role === UserRole.COMPANY_ADMIN
  },
  {
    labelKey: "sidebar-company",
    defaultLabel: "Company",
    icon: "storeOutlined",
    path: `${PORTAL_PREFIX}/${PAGE_PORTAL_COMPANY}`,
    testId: "sidebar-nav-company",
    visible: (role) => role === UserRole.COMPANY_ADMIN
  },
  {
    labelKey: "sidebar-store",
    defaultLabel: "Store",
    icon: "storeOutlined",
    path: `${PORTAL_PREFIX}/${PAGE_PORTAL_STORE}`,
    testId: "sidebar-nav-store",
    visible: (role) => role === UserRole.STORE_ADMIN
  }
];
